/*
 * formReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 12-Jan-2023
 */

import produce from 'immer';
import { actionTypes } from '../actions/form';

const ACTION_HANDLERS = {
	[actionTypes.GET_COUNTRIES_REQUEST]: produce((draft, action) => {}),
	[actionTypes.GET_COUNTRIES_SUCCESS]: produce((draft, action) => {
		draft.countries = action.response.countries.map((item) => {
			const country = {
				content: item.name,
				value: item.name,
			};
			return country;
		});
	}),
	[actionTypes.GET_COUNTRIES_FAILURE]: produce((draft, action) => {}),
	// @generator reducer:type:action
};

// The initial state of the form
const initialState = {};

const form = (state = initialState, action) => {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
};

export default form;
